// @ts-nocheck
import { createAsyncAction } from '../../../core/store/actionCreators';
import {
  CLOSE_CAMPAIGN,
  CREATE_CAMPAIGN,
  CREATE_CAMPAIGN_SERIES,
  FETCH_CAMPAIGN,
  FETCH_CAMPAIGNS,
  FETCH_CAMPAIGN_PRODUCTS,
  FETCH_CAMPAIGN_SERIES_SEGMENTS,
  FETCH_CAMPAIGN_SERIES,
  UPDATE_CAMPAIGN,
  UPDATE_CAMPAIGN_SERIES,
  UPDATE_CURRENT_PAGE,
} from './campaignActionTypes';
import CampaignService from '../services/CampaignService';
import { ProductService } from '../../products';

export const fetchCampaigns = createAsyncAction(
  FETCH_CAMPAIGNS,
  async (page, size, filterParams, sortParams) => {
    const { data } = await CampaignService.fetchCampaigns(page, size, filterParams, sortParams);
    return data;
  }
);

export const fetchCampaign = createAsyncAction(FETCH_CAMPAIGN, async campaignId => {
  const { data } = await CampaignService.fetchCampaign(campaignId);
  return data;
});

export const fetchCampaignSeries = createAsyncAction(
  FETCH_CAMPAIGN_SERIES,
  async (campaignId, onlyActive) => {
    const { data } = await CampaignService.fetchCampaignSeries(campaignId, onlyActive);
    return data;
  }
);

export const fetchCampaignProducts = createAsyncAction(FETCH_CAMPAIGN_PRODUCTS, async () => {
  const { data } = await ProductService.fetchProducts({ onlyBuyable: true, channels: false, clientSegment: 'commercial' });
  return data;
});

export const fetchSeriesSegments = createAsyncAction(FETCH_CAMPAIGN_SERIES_SEGMENTS, async () => {
  const { data } = await CampaignService.fetchSeriesSegments();
  return data;
});

export const closeCampaign = createAsyncAction(CLOSE_CAMPAIGN, async campaignId => {
  const { data } = await CampaignService.closeCampaign(campaignId);
  return data;
});

export const createCampaign = createAsyncAction(CREATE_CAMPAIGN, async campaignData => {
  const { data } = await CampaignService.createCampaign(campaignData);
  return data;
});

export const updateCampaign = createAsyncAction(UPDATE_CAMPAIGN, async (campaignId, campaignData) => {
  const { data } = await CampaignService.updateCampaign(campaignId, campaignData);
  return data;
});

export const createCampaignSeries = createAsyncAction(CREATE_CAMPAIGN_SERIES, async seriesData => {
  const { data } = await CampaignService.createCampaignSeries(seriesData);
  return data;
});

export const updateCampaignSeries = createAsyncAction(UPDATE_CAMPAIGN_SERIES, async seriesData => {
  const { data } = await CampaignService.updateCampaignSeries(seriesData);
  return data;
});

export const updateCurrentPage = createAsyncAction(UPDATE_CURRENT_PAGE, async page => page);
